import React, { useEffect, useState, useRef } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Typography
} from "@mui/material";
import { MoreVert as MoreIcon, LocationOn as MapMarkerIcon } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { FETCH_PROJECTS_COMPANIES } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import { useNavigate } from "react-router-dom";
import { BIGrey, BIRed } from "../../assets/helpers";
import defaultProjectImage from "../../assets/images/placeholder_img.jpg";
import SearchField from "../common/SearchField";
import { setSelectedProjectdata, setShowmapmodal } from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import { setShowReport } from "../../redux/actions/actions";
import Emptydata from "../common/Emptydata";
import { English } from "../../constant/EnglishFallback";
import InfiniteScroll from "react-infinite-scroll-component";
import Pages from "../../constant/ReportModel";

function CompanyProjectSection({ id, scrollId }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loginData, selectedProject, multiLanguageData, reportSuccess } = useSelector(
    (state) => state?.main
  );
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const LanguageData = multiLanguageData?.Companies || {};
  const {
    BUTTON_ADD_PROJECT = English.Companies.BUTTON_ADD_PROJECT,
    TEXT_COMPANY_PROJECTS_DESC = English.Companies.TEXT_COMPANY_PROJECTS_DESC,
    TEXT_SEARCH_COMPANY_PROJECTS = English.Companies.TEXT_SEARCH_COMPANY_PROJECTS,
    BUTTON_REPORT = English.Companies.BUTTON_REPORT,
    TEXT_NO_RESULTS_FOUND = English.Companies.TEXT_NO_RESULTS_FOUND,
    TEXT_NO_PROJECT_FOUND = English.Companies.TEXT_NO_PROJECT_FOUND
  } = LanguageData || {};
  const debounceTimeout = useRef(null);

  const [projectData, setProjectData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showSearchLoader, setShowSearchLaoder] = useState(false);
  const [hasData, setHasData] = useState(false);
  const [projectDetails, setProjectDetails] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [allDataLoaded, setAllDataLoaded] = useState(false);

  useEffect(() => {
    if (reportSuccess !== true) {
      getInitialData();
    }
  }, [reportSuccess]);

  useEffect(() => {
    if (selectedProject?.from === "company-detail") {
      getInitialData();
      dispatch(setSelectedProjectdata(null));
    }
  }, [selectedProject]);

  const getInitialData = async () => {
    setIsLoading(true);
    await getProjectData(searchTerm, 1, "fristTimeApiCall");
    setIsLoading(false);
  };

  const getProjectData = async (searchTerm, pageNumber, fristTimeApiCall) => {
    try {
      setAllDataLoaded(true);
      const obj = {
        PageNr: pageNumber,
        NrOfRecPerPage: 20,
        FullSearch: searchTerm ?? "",
        SearchList: [
          {
            companyId: id
          }
        ],
        userId: currentUserId,
        IncludeRecordNr: true,
        SortList: [{}],
        FetchAllowedRecordsOnly: true,
        TypeOfObjectReturned: ""
      };
      // API call to fetch project data
      const getResponse = await Postrequestcall(
        FETCH_PROJECTS_COMPANIES,
        obj,
        loginData?.accessToken
      );
      if (getResponse.status === 200) {
        let resData =
          getResponse?.data?.data?.sort((a, b) => a?.projectName?.localeCompare(b?.projectName)) ??
          [];
        if (pageNumber > 1) {
          setTimeout(() => {
            setProjectData((prevProducts) => [...prevProducts, ...resData]);
          }, 500);
        } else {
          setProjectData(resData);
          if (fristTimeApiCall) {
            setHasData(resData?.length > 0);
          }
        }
      }
    } catch (error) {
      setAllDataLoaded(false);
      console.log("getProjectData-> Error Fetching Project Companies: ", error);
    } finally {
      setShowSearchLaoder(false);
      setIsLoading(false);
      setAllDataLoaded(false);
    }
  };

  const handleOpenReportModal = () => {
    setMoreMenuAnchorEl(null);
    let reportObj = {
      showReport: true,
      recordId: projectDetails.projectId ?? 0,
      name: Pages?.projects?.name,
      AppScreenId: Pages?.projects?.id
    };
    console.log("reportObj", reportObj);
    dispatch(setShowReport(reportObj));
  };

  const onAddProjectClick = () => {
    let mapModal = {
      open: true,
      from: "company-detail",
      select: "project"
    };
    dispatch(setShowmapmodal(mapModal));
  };

  const onItemClick = (item) => {
    navigate(`/project/${item?.projectId}`);
  };

  const increaseOffset = (callback) => {
    setPageNumber((prevPageNr) => prevPageNr + 1);
    callback(pageNumber + 1);
  };

  const NoInformation = () => {
    return (
      <Stack  sx={{ gap: 1, height: "100%" }}>
        <Button variant="text" sx={{ alignSelf: "flex-end" }} onClick={onAddProjectClick}>
          {BUTTON_ADD_PROJECT}
        </Button>
        <Box className="empty-data-card">
          <Emptydata
            icon={<MapMarkerIcon className="emptydata-icon" />}
            firstText={TEXT_NO_PROJECT_FOUND}
          />
        </Box>
      </Stack>
    );
  };

  const renderListing = () => {
    return (
      <Stack sx={{ gap: 1 }} >
        <Typography variant="body1" sx={{ color: "text.secondary" }}>
          {TEXT_COMPANY_PROJECTS_DESC}
        </Typography>
        <SearchField
          placeholder={TEXT_SEARCH_COMPANY_PROJECTS}
          value={searchTerm}
          onChange={(value) => {
            setShowSearchLaoder(true);
            const searchValue = value;
            setSearchTerm(searchValue);
            if (debounceTimeout.current) {
              clearTimeout(debounceTimeout.current);
            }
            debounceTimeout.current = setTimeout(() => {
              getProjectData(value, 1);
            }, 1000);
          }}
          onSubmit={() => {
            setShowSearchLaoder(true);
            setShowSearchLaoder(searchTerm);
            getProjectData(searchTerm, 1);
          }}
          size={"small"}
        />
        <Button variant="text" sx={{ alignSelf: "flex-end" }} onClick={onAddProjectClick}>
          {BUTTON_ADD_PROJECT}
        </Button>
        <Stack spacing={1}>
          {showSearchLoader ? (
            <Stack style={{ padding: "30px" }}>
              <Loader />
            </Stack>
          ) : projectData?.length > 0 ? (
            <>
              <InfiniteScroll
                dataLength={projectData?.length}
                next={async () => {
                  increaseOffset((pageNumber) => {
                    getProjectData(searchTerm, pageNumber);
                  });
                }}
                hasMore={true}
                loader={
                  !allDataLoaded ? null : (
                    <h4 style={{ display: "flex", justifyContent: "center" }}>
                      <Loader />
                    </h4>
                  )
                }
                scrollableTarget={scrollId}>
                <List disablePadding>
                  <Stack sx={{ gap: 1 }} >
                    {projectData.map((item) => (
                      <Card key={item?.id} className="pagelist-content">
                        <ListItem
                          key={item?.id}
                          style={{ padding: "0px" }}
                          secondaryAction={
                            <IconButton
                              onClick={(event) => {
                                setProjectDetails(item);
                                setMoreMenuAnchorEl(event.currentTarget);
                              }}>
                              <MoreIcon />
                            </IconButton>
                          }>
                          <ListItemButton
                            onClick={() => {
                              onItemClick(item);
                            }}>
                            <Avatar
                              variant="rounded"
                              style={{ margin: "5px 15px 5px 5px" }}
                              src={item?.thumbUrl || defaultProjectImage}
                            />
                            <ListItemText
                              primary={item?.projectName}
                              secondary={item?.projectAddress}
                            />
                          </ListItemButton>
                        </ListItem>
                      </Card>
                    ))}
                  </Stack>
                </List>
                <Menu
                  anchorEl={moreMenuAnchorEl}
                  open={Boolean(moreMenuAnchorEl)}
                  onClose={() => setMoreMenuAnchorEl(null)}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}>
                  <MenuItem onClick={() => handleOpenReportModal()} style={{ color: BIRed }} dense>
                    {BUTTON_REPORT}
                  </MenuItem>
                </Menu>
              </InfiniteScroll>
            </>
          ) : (
            <Stack sx={{ justifyContent: "center", alignItems: "center" }} direction={"row"} style={{ color: BIGrey, padding: "30px" }}>
              {TEXT_NO_RESULTS_FOUND}
            </Stack>
          )}
        </Stack>
      </Stack>
    );
  };

  return (
    <Box className="main-content-card-list">
      <Card className="pagelist-content" sx={{ p: 2 }}>
        {isLoading ? <Loader /> : hasData ? renderListing() : <NoInformation />}
      </Card>
    </Box>
  );
}

export default CompanyProjectSection;

